package utils

import kotlinx.browser.document
import org.w3c.dom.HTMLAudioElement

@Suppress("EXPECT_ACTUAL_CLASSIFIERS_ARE_IN_BETA_WARNING")
actual class AudioPlayer actual constructor() {
    private val audio = (document.createElement("audio") as HTMLAudioElement).apply {
        src = "audio/bgm.webm"
        loop = true
        muted = true
        autoplay = false
    }

    actual fun play() {
        audio.muted = false
        audio.play().catch { console.log("Autoplay blocked: $it") }
    }

    actual fun mute() {
        audio.muted = true
    }

    actual fun unmute() {
        audio.muted = false
    }

    actual fun pause() {
        audio.muted = true
        audio.pause()
    }
}